import { Divider, IconButton, Stack, Typography, useTheme } from '@mui/material';
import type { Currency } from '@vy/types';
import React from 'react';
import { CloseIcon } from '../../../../../../components/icons';
import { LivePreviewContainerHeader } from './LivePreviewContainerHeader/LivePreviewContainerHeader';

type LivePreviewContainerProps = React.PropsWithChildren<{
  title: React.ReactNode;
  currency: Currency;
  itemsCount: number;
  totalAmount: number;
  onHide?: () => void;
}>;

export const LivePreviewContainer: React.FC<LivePreviewContainerProps> = ({
  children,
  title,
  currency,
  itemsCount,
  totalAmount,
  onHide,
}) => {
  const theme = useTheme();

  return (
    <Stack
      direction="column"
      divider={<Divider />}
      sx={{
        position: "relative",
        width: "400px",
        height: "100%",
        bgcolor: "white",
        borderLeft: `1px solid ${theme.palette.divider}`
      }}>
      <Stack
        direction="row"
        sx={{
          position: "relative",
          padding: 2,
          justifyContent: "space-between",
          alignItems: "center",
          paddingBottom: "18px"
        }}>
        <Typography variant="h6">{title}</Typography>
        <IconButton onClick={onHide}>
          <CloseIcon color="#576063" />
        </IconButton>
      </Stack>
      <Stack
        direction="column"
        sx={{
          paddingY: 2,
          paddingX: 3,
          overflow: "auto"
        }}>
        <LivePreviewContainerHeader currency={currency} itemsCount={itemsCount} totalAmount={totalAmount} />
      </Stack>
      {children}
    </Stack>
  );
};
